import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "../../components/PageContainer";
import MainContent from "../../components/MainContent";
import PageTitle from "../../components/Common/PageTitle/PageTitle";
import ActionDropdownItem from "../../components/Common/PageTitle/ActionDropdownItem";
import ActivityLoader from "../../components/Common/ActivityLoader";
import functions from "../../util/functions";
import { useTheme } from "../../DataStore/ThemeContext";
import StudentProfileInfo from "../../components/Student/StudentProfileInfo";
import { useStudent } from "../../DataStore/StudentContext";
import ContactSection from "../../components/Student/ContactSection";
import AlertDefaultContact from "../../components/Student/AlertDefaultContact";
import FileSection from "../../components/Student/FileSection";
import ReportSection from "../../components/Student/ReportSection";
import AlertDeleteContact from "../../components/Student/AlertDeleteContact";
import AlertChangeStatus from "../../components/Student/AlertChangeStatus";
import ajaxStudent from "../../util/remote/ajaxStudent";
import Notification from "../../components/Common/Notification";
import AlertDeleteFile from "../../components/Student/AlertDeleteFile";
import AlertReportViewer from "../../components/Student/AlertReportViewer";
import ajaxReport from "../../util/remote/ajaxReport";

const StudentProfilePage = () => {
  const {
    profileInfo,
    studentId,
    feesBalance,
    loadProfile,
    studentReports,
    studentContacts,
    studentAttachments,
  } = useStudent();
  const navigate = useNavigate();
  const [showActivation, setShowActivation] = useState(false);
  const { setNotify, openSettings } = useTheme();
  const [showReportViewer, setShowReportViewer] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(null);


  useEffect(() => {
    if (!studentId) {
      navigate("/");
    }
  }, [studentId]);

  useEffect(() => {
    if(selectedReport) {
      setShowReportViewer(true);
      loadReport(selectedReport.id);
    }
  }, [selectedReport]);

  const handleChangeStatus = async() => {
    const newStatus = profileInfo?.status * 1 === 1 ? 0 : 1;
    const server_response = await ajaxStudent.changeStudentStatus({
      student_id: studentId,
      status: newStatus,
    });
    if(server_response.status === "OK"){
        setNotify(<Notification type='success' message={server_response.message}/>)
        loadProfile(studentId);
    }
    else {
        setNotify(<Notification type='danger' message={server_response.message}/>)
    }
    setShowActivation(false);
  }

  const handleChangePhoto = () => {
    openSettings("Change Student Photo", "NewStudenPhoto", studentId);
  }

  const handleEditStudent = () => {
    navigate("/student-edit", {
      state: {
        studentId: studentId,
        profileInfo: profileInfo,
      },
    });
  };

  const handleReportClick = (report) => {
    setSelectedReport(report);
  };

  const loadReport = async (reportId) => {
    setGeneratedReport(null);
    const server_response = await ajaxReport.loadStudentReport({ report_id: reportId, student_id: studentId });
    if (server_response.status === "OK") {
      setGeneratedReport(server_response.details);
    } else {
      // Handle error
      setNotify(<Notification type='danger' message={server_response.message}/>);
    }
  };

  const PageActions = () => (
    <>
      <ActionDropdownItem iconClass="fa fa-bullseye text-primary" label={`${profileInfo?.status*1 === 1 ? 'Deactivate' : 'Activate'} Student`} onClick={()=>setShowActivation(true)}/>
      <ActionDropdownItem iconClass="fa fa-image text-success" label="Change Photo"onClick={handleChangePhoto} />
      <ActionDropdownItem iconClass="fa fa-pencil text-primary" label="Edit Student" onClick={handleEditStudent}/>
      <ActionDropdownItem iconClass="fa fa-trash-alt text-danger" label="Delete Student" />
      <ActionDropdownItem iconClass="fa fa-refresh text-success" label="Refresh" onClick={()=>loadProfile(studentId)} />
    </>
  );

  return (
    <>
      <PageContainer>
        <MainContent>
          <PageTitle
            title="Student Profile"
            description="View and manage student info."
            iconClass="fa fa-user-circle"
            PageActions={PageActions}
            sticky={true}
          />
          <div className="row">
            <div className="col-lg-4">
              <div className="card shadow-sm mb-4">
                <div className="card-body text-center">
                  {functions.isObject(profileInfo) && <StudentProfileInfo profileInfo={profileInfo} />}
                  {!profileInfo && <ActivityLoader />}
                </div>
              </div>
              <div className="card bg-white shadow-sm mb-4">
                <div className="card-body text-center">
                  <h6 className="text-uppercase text-muted">Fees Balance</h6>
                  <h3 className={`${feesBalance > 0 ? "text-danger" : "text-success"}`}>UGX {feesBalance ? functions.numberFormat(feesBalance) : 0}</h3>
                  <p className="text-muted small">Current outstanding balance</p>
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="row">
                <div className="col-md-12 mb-4">
                  <FileSection files={studentAttachments}/>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-4">
                 <ReportSection reports={studentReports} onSelect={handleReportClick}/>
                </div>

                <div className="col-md-6 mb-4">
                  <ContactSection contacts={studentContacts} />
                </div>

              

              </div>
            </div>
          </div>
          {!profileInfo && <ActivityLoader />}
        </MainContent>
      </PageContainer>
      <AlertDefaultContact />
      <AlertDeleteContact />
      {showActivation && <AlertChangeStatus
        show={showActivation}
        handleClose={() => setShowActivation(false)}
        title="Change Student Status"
        description={`Are you sure you want to ${profileInfo.status * 1 === 1 ? 'deactivate' : 'activate'} this student?`}
        onConfirm={handleChangeStatus}
      />}
      <AlertDeleteFile />
      <AlertReportViewer
        show={showReportViewer}
        onClose={() => { setShowReportViewer(false); setSelectedReport(null); }}
        report={generatedReport}
        reportInfo={selectedReport}
      />
    </>
  );
};

export default StudentProfilePage;
